import { Store } from "@storeLocator/storeType";
import React from "react";
import OpenclosingTime from "./OpenClosingTime";

interface FinalFormData {
  FirstName: string;
  LastName: string;
  Email: string;
  CellPhone: string;
  HomeZipcode: string;
  Time: string;
  StoreLocation: any;
}
interface ThankyouPageProps {
  data: FinalFormData;
}
const ThankyouPage = ({ data }: ThankyouPageProps) => {
  const formatDate = (time: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    return time.toLocaleDateString("en-US", options).replace(",", " at");
  };
  return (
    <div className="flex flex-col">
      <h2 className="mb-[15px] text-left font-body text-[28px] font-bold italic leading-[36px] tracking-[1.12px] text-darkPurple md:text-[36px] md:leading-[40px] md:tracking-[1.44px]">
        See you soon.
      </h2>
      <div className="flex flex-wrap justify-start gap-[30px] sm:gap-[20px]">
        <div className="mx-auto mt-[15px] w-full max-w-[335px] sm:mx-0 sm:max-w-[320px] md:mt-0">
          <div className="rounded-[8px_8px_0px_0px] bg-armyGreen px-[15px] py-[10px]">
            <h2 className="font-heading text-[28px] font-light italic leading-[36px] tracking-[1.12px] text-formCreamWhite">
              Your Store
            </h2>
          </div>
          {data && (
            <div className="rounded-[0px_0px_15px_15px] bg-white p-5">
              <div>
                <p className="text-creamyBlack font-body text-base leading-[24px] tracking-[0.16px]">
                  {data.StoreLocation.streetAndNumber}
                  <br />
                  {data.StoreLocation.city}, {data.StoreLocation.province}{" "}
                  {data.StoreLocation.zip}
                  <br />
                  {data.StoreLocation.cellphone && (
                    <>
                      <a
                        className="underline"
                        href={`tel:${data.StoreLocation.cellphone}`}
                      >
                        {data.StoreLocation.cellphone}
                      </a>
                      <br />
                    </>
                  )}
                  <OpenclosingTime
                    storeHours={data.StoreLocation.openingHours}
                  />
                </p>
                {data.StoreLocation.lat && data.StoreLocation.lng && (
                  <div className="mt-5">
                    <a
                      target="_blank"
                      className="text-everglade underline"
                      href={`https://www.google.com/maps?saddr=Current+Location&daddr=@${data.StoreLocation.lat},${data.StoreLocation.lng}`}
                    >
                      Directions to your store
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="mx-auto mb-[20px] w-full max-w-[335px] sm:mx-0 sm:max-w-[320px]">
          <div className="rounded-[8px_8px_0px_0px] bg-armyGreen px-[15px] py-[10px]">
            <h2 className="font-heading text-[28px] font-light italic leading-[36px] tracking-[1.12px] text-formCreamWhite">
              What to Bring
            </h2>
          </div>
          <div className="text-body text-creamyBlack rounded-[0px_0px_15px_15px] bg-white p-5 leading-[24px] tracking-[0.16px]">
            <ul className="">
              <li>
                <strong>&#x2022; Personal info.</strong> Phone number, Social
                Security Number, and a valid ID.
              </li>
              <li>
                <strong>&#x2022; Steady income.</strong> Net and gross pay, and
                income information.
              </li>
              <li>
                <strong>&#x2022; Banking info.</strong> Checking account and
                routing numbers.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankyouPage;
